import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs/Subscription';
import { NgbProgressbarConfig } from '@ng-bootstrap/ng-bootstrap';
import  { GridOptions }  from  "ag-grid/main";
import { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { debounceTime } from 'rxjs/operators';
import { CommonUtility, CaseNotes, CaseNotesSummary,VIEW_BTN , AgGridUtility } from '../shared';
import { DateUtility, ServerConstantsService,SINGLE_ROW_HEADER } from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { DataService, MIN_CHAR_SEARCH_LENGTH } from '../shared';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'app-case-notes-summary',
  templateUrl: './case-notes-summary.component.html',
  styleUrls: ['./case-notes-summary.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class CaseNotesSummaryComponent implements OnInit {
  SINGLE_ROW_HEADER=SINGLE_ROW_HEADER;
  caseNote: CaseNotes;
  caseNotes: CaseNotes[] = [];
  caseNotesList: CaseNotesSummary;
  programMap: any;
  tabIndex:any = "-1";
  relationshipArray: any[];
  relationshipMap: any;
  elasticSuggestions = new BehaviorSubject<any>(null);
  elasticSuggestionsUser = new BehaviorSubject<any>(null);
  suggestions: any = [];
  suggestionsUser: any = [];
  ServerConstants: any;
  userActionNotificationsMap: any;
  refData: any;
  currentSearch: String;
  wpenrollmentId: string = '';
  wpPersonId: string = '';
  noData: Boolean = false;
  error: Boolean = false;
  caseNoteMap: any;
  gridOptions;
  columnDefs: any;
  context: any;
  taskTypesJson: any;
  taskStatusJson: any;
  countiesJson: any;
  countiesMap: any;
  counties: any;
  assignedToJson: any;
  assignedToMap: any;
  assignedToDD: any;
  caseNoteArray: any[];
  private _success = new Subject<string>();
  successMessage: string;
  private _danger = new Subject<string>();
  errorMessage: string;
  sharedData: any;

  gridApi: any;
  tabToNextCell: any;
  index : any;
  firstTime: Boolean = true;

  @ViewChild('header') header: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    public dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private agGridUtility: AgGridUtility,
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
    this.gridOptions  =  <GridOptions>{};
    if(this.dataService.getSharedDataObject().get('CSNTS') == undefined){
      this.router.navigate(['/task']);
    }
  }

  ngOnInit() {
    //Initialize class variables
    this.index = this.dataService.getSharedDataObject().get("CSNTS").innerNavPages.find(x=> x.pageId === 'CSNSU');
    if(this.index.readOnly){
      this.tabIndex = "0";
    }
    this.noData = false;
    /* set global values for page */
    this.sharedData = this.dataService.getSharedDataObject();
    this.wpenrollmentId = this.sharedData.get('enrollmentId');
    this.wpPersonId = this.sharedData.get('wpPersonId');
    //this.wpPerson = new WpPerson();
    //this.wpPerson.id = parseInt(this.wpPersonId);
    this.caseNote = new CaseNotes();
    //this.caseNote.person = this.wpPerson;
    this.caseNotesList = new CaseNotesSummary();
    this.caseNotesList.person_id = parseInt(this.wpPersonId)
    /* Load Reference Tables*/
    this.data.currentMessage.subscribe(
      (message) => {
        this.refData = message;
        this.parseRefTableData(message);
      });
    this.load(this.caseNote);
    this.getColumnDefinitions();
    console.log(this.columnDefs);
  }
  getColumnDefinitions() {
    this.columnDefs = [
      {
        headerName: 'Created Date',
        field: 'createdDt',
        valueFormatter: this.agGridUtility.formatTimeDateToDate,
        width: 180,
        filterParams: {
          comparator: this.filterDates,
        },
      },
      {
        headerName: 'Created By',
        field: 'createdBy',
      },
      {
        headerName: 'Type',
        field: 'typeCd',
        refData: this.taskStatusJson,
        valueGetter: this.getTaskType,
      },
      {
        headerName: 'Notes',
        field: 'notes',
        width: 200,
      },
      {
        headerName: 'Action',
        field: '',
        cellRenderer: this.getEditButton,
        width: 100,
        suppressFilter: true,
        suppressSorting: true

      },
    ];

    this.tabToNextCell = function tabToNextCell(params) {
      const nextCell = params.nextCellDef;
      if (nextCell == null || nextCell.column.colDef.headerName === 'Action') {
        return;
      } else {
        return nextCell;
      }
    };


    this.context = {
      component: this,
    };
  }
  getTaskType(params){
    const task: CaseNotes = params.data;
    const that = params.context.component;
    return that.caseNoteMap.get(task.typeCd);
  }
  getEditButton(params) {
    const that = params.context.component;
    const element = document.createElement('a');
    const image = VIEW_BTN ;
    element.innerHTML = image;
    element.setAttribute("tabindex","0");

    element.addEventListener('click', () => {
      that.dataService.addValueToSharedDataMap('caseNotes', params.data);
      that.router.navigate(['/task/caseNotesSummary/caseNotes']);
    });
    element.addEventListener('keydown', (event) => {
      if(event.keyCode == 13 || event.keyCode == 32) {
        that.dataService.addValueToSharedDataMap('caseNotes', params.data);
        that.router.navigate(['/task/caseNotesSummary/caseNotes']);
      }
      /*else if((!event.shiftKey && event.keyCode===9) && (params.rowIndex === (that.caseNotes.length -1))){
        event.preventDefault();
        setTimeout(() => that.header.nativeElement.focus(), 0);
        that.header.nativeElement.click();
      }*/
    });
    return element;
  }

  formatDates(params) {
    if (!params.value) {
      return null;
    }
    const dateParts = params.value.split('/');
    const day = dateParts[2];
    const month = dateParts[1];
    const year = dateParts[0];
    const dayParts =(String(day)).split(" ");
    return month + '/' + dayParts[0] + '/' + year;
  }

  filterDates(filterLocalDateAtMidnight, cellValue) {
    if (!cellValue) {
      return;
    }
    const dateParts = cellValue.split('/');
    const day = Number(dateParts[2]);
    const month = Number(dateParts[1]) - 1;
    const year = Number(dateParts[0]);
    const cellDate = new Date(year, month, day);
    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    } else if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    } else {
      return 0;
    }
  }

  onGridReady(params) {
    this.gridApi = params.api
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  onResize(event) {
    if(window.screen.width >= window.innerWidth){
      this.gridApi.columnDefs = this.columnDefs;
    }
    else{
      this.gridApi.sizeColumnsToFit();
    }
  }

  getCaseNotesIdLink(params) {
    const that = params.context.component;
    const element = document.createElement('a');
    element.innerHTML = params.data.id;
    element.addEventListener('click', () => {
      return;
    });
    return element;
  }

  load(request) {
    this.http.post<CaseNotesSummary>(this.ServerConstants.SERVER_API_URL + '/casenotes/load', this.caseNotesList).subscribe(
      (data: CaseNotesSummary) => {
        if (data.hasOwnProperty('errorCode')) {
          this.notificationService.error('CaseNotes Summary', this.userActionNotificationsMap.ERROR);
        } else {
          if (data != null) {
            if (data.caseNotes.length > 0) {
              this.caseNotes = data.caseNotes;
            } else {
              this.caseNotes =[];
              this.noData = true;
            }
          }
        }
      }, response => {
        this.error = true;
        this.notificationService.error('CaseNotes Summary', this.userActionNotificationsMap.ERROR);
      }, () => {
        this.error = false;
      });
  }
  loadCaseNotesDetails() {
    this.router.navigate(['/task/caseNotesSummary/caseNotes']);
    this.dataService.removeValueFromSharedDataMap('caseNotes');
  }
  parseRefTableData(myData) {
    if (myData != undefined && myData.englishDropDown) {
      this.caseNoteArray = myData.englishDropDown["CASENOTE_ACTIVITY_TYPES"];
      this.caseNoteMap = this.commonUtil.createMapFromList(this.caseNoteArray);
      this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(myData.englishDropDown["USER-ACTION-NOTIFICATIONS"]);
      this.taskStatusJson = this.commonUtil.createNativeMapFromList(this.caseNoteArray);
    }
  }

  convertCode(myMap, code) {
    if (myMap != undefined) {
      return myMap.get(code);
    }
  }

  public  onQuickFilterChanged($event) {
    this.gridOptions.api.setQuickFilter($event.target.value);
  }

  focusSummary(e: KeyboardEvent) {
    this.firstTime = false;
    this.addEventListenerToSearch(event);
  }

  addEventListenerToSearch(event){
    var tabKeyCode = 9;

    // ignore non tab key strokes
    if(event.keyCode !== tabKeyCode) {
      return;
    }

    if(this.caseNotes.length === 0){
      return;
    }

    if(event.shiftKey){
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }

  setDisplayedRowAtIndex() {
    // get the first row
    var index = this.gridApi.getFirstDisplayedRow();
    var rowNode = this.gridApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }
  onPaginationChanged(event) {
    if (this.firstTime) {
      return;
    } else {
      if (this.gridApi) {
        this.setDisplayedRowAtIndex();
      }
    }
  }

  gridClick() {
    this.firstTime = false;
  }

  focusing(event) {
    if (!event.shiftKey && event.keyCode === 9) {
      event.preventDefault();
      setTimeout(() => this.header.nativeElement.focus(), 0);
      this.header.nativeElement.click();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/case-notes-summary/case-notes-summary.component.ts